let dataLayerInited = false;
export class DataLayerTracker {
    constructor(data) {
        this.dataLayer = this.init(data);
    }

    /**
     * Инициализируем начальный dataLayer
     * @param data
     * @returns {*|Array}
     */
    init(data) {
        window.dataLayer = window.dataLayer || [];
        if (dataLayerInited) {
            return window.dataLayer;
        }

        const initialLayer = {
            isLogged: data.user.authorized,
        };

        if (initialLayer.isLogged) {
            initialLayer.user = {
                birthdate: data.user.born_at
                    ? data.user.born_at.short
                    : "unknown",
                gender: data.user.gender ? data.user.gender : "unknownn",
                regDate: data.user.registered_at.short,
            };
        }

        switch (data.route) {
            case "index":
                initialLayer.pagetype = "main";
                break;
            case "products":
                initialLayer.pagetype = "catalog";
                break;
            case "product":
                initialLayer.pagetype = "product";
                break;
            case "search":
                initialLayer.pagetype = "search";
                break;
            case "cart":
                initialLayer.pagetype = "basket";
                break;
            case "order":
                initialLayer.pagetype = "order";
                break;
            case "order.thankyoupage":
                initialLayer.pagetype = "confirmation";
                break;
            case "404":
                initialLayer.pagetype = "404";
                break;
            default:
                initialLayer.pagetype = "other";
                break;
        }

        window.dataLayer.push(initialLayer);

        dataLayerInited = true;
        return window.dataLayer;
    }

    push(layer) {
        this.dataLayer.push(layer);
    }

    productPageView(product) {
        this.push({
            ecommerce: {
                detail: {
                    products: {
                        name: product.name,
                        id: product.id,
                        price: parseFloat(product.price),
                        brand: "Таврос",
                        category: product.category,
                        variant: product.name,
                        list: product.list,
                        position: product.id,
                    },
                },
            },
        });
    }

     productPageSearch(search) {
        this.push({
            event: "ecommerceImpressions",
            ecommerce: {
                impressions: {
                    products: search,
                },
            },
        });
    }
    productAnalogPageView(analogProduct) {
        this.push({
            event: "ecommerceImpressions",
            ecommerce: {
                impressions: {
                    products: analogProduct,
                },
            },
        });
    }
    productViewedPageView(viewedProduct) {
        this.push({
            event: "ecommerceImpressions",
            ecommerce: {
                impressions: {
                    products: viewedProduct,
                },
            },
        });
    }

     categoryPageView(productsCategory) {
        this.push({
            event: "ecommerceImpressions",
            ecommerce: {
                impressions: {
                    products: productsCategory,
                },
            },
        });
    }

    basketItemAdd(product) {
        this.push({
            event: "addToCart",
            ecommerce: {
                add: {
                    products: collectBasketItems([product]),
                },
            },
        });
    }


orderPageView(basket) {
        this.push({
            ecommerce: {
                checkout: {
                    products: collectBasketItems(basket),
                },
            },
        });
    }



    basketPageView(basket) {
        this.push({
            ecommerce: {
                checkout: {
                    actionField: { step: 1 },
                    products: collectBasketItems(basket),
                },
            },
        });
    }

    orderPageReload(basket) {
        this.push({
            ecommerce: {
                checkout: {
                    actionField: { step: 3 },
                    products: collectBasketItems(basket),
                },
            },
        });
    }

    orderPageLoyalityCardValidtion(card) {
        this.push({
            event: "checkoutOption",
            ecommerce: {
                checkout_option: {
                    actionField: {
                        step: 2,
                        option: "подтвердил пин код бонусной карты",
                    },
                    card1: card.number,
                    card2: card.pin,
                },
            },
        });
    }

    orderThankyouPageView(order, basket) {
        console.log(order);
        console.log(basket);
        this.push({
            event: "Transaction",
            ecommerce: {
                purchase: {
                    actionField: {
                        id: order.id,
                        affiliation: "Таврос",
                        revenue: order.price,
                        tax: order.tax,
                        shipping: order.delivery_price,
                        coupon: order.coupon,
                    },
                    products: collectBasketItems(basket),
                },
            },
        });
    }
}

let collectBasketItems = (basket) => {
    const items = [];
    basket.forEach((basketItem) => {
        items.push(formatBasketItem(basketItem));
    });
    return items;
};

let formatBasketItem = (product) => {
    if (!product) {
        return {};
    }
    return {
        name: product.name,
        id: product.id,
        price: product.price,
        brand: "Таврос",
        category: product.category,
        variant: "",
        quantity: product.quantity,
    };
};
